import { useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { initGA, trackPageView, trackEvent, trackException, trackTiming } from '../utils/analytics';
import { logger } from '../utils/logger';
import { GA_MEASUREMENT_ID } from '../utils/config';

const useAnalytics = () => {
  const location = useLocation();

  // Initialize Google Analytics
  useEffect(() => {
    if (GA_MEASUREMENT_ID) {
      initGA(GA_MEASUREMENT_ID);
      logger.info({ measurementId: GA_MEASUREMENT_ID }, 'Google Analytics initialized');
    } else {
      logger.warn('Google Analytics Measurement ID not found in environment variables');
    }
  }, []);

  // Track page views when the location changes
  useEffect(() => {
    if (GA_MEASUREMENT_ID) {
      trackPageView(location.pathname + location.search);
    }
  }, [location]);

  // Helper functions for tracking various metrics
  const logEvent = useCallback(
    (category: string, action: string, label?: string, value?: number) => {
      if (GA_MEASUREMENT_ID) {
        trackEvent(category, action, label, value);
      }
    },
    []
  );

  const logException = useCallback(
    (description: string, fatal: boolean = false) => {
      if (GA_MEASUREMENT_ID) {
        trackException(description, fatal);
      }
    },
    []
  );

  const logTiming = useCallback(
    (category: string, variable: string, value: number, label?: string) => {
      if (GA_MEASUREMENT_ID) {
        trackTiming(category, variable, value, label);
      }
    },
    []
  );

  return {
    logEvent,
    logException,
    logTiming,
  };
};

export default useAnalytics; 